var wait = function wait(delay) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, delay);
  });
};

var fetchRetry = function fetchRetry(fetchClient, url, delay, tries) {
  var fetchOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var qos = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  function onError(res) {
    var triesLeft = tries - 1; // eslint-disable-next-line no-console

    console.log("Calling to ".concat(url, " error. Status ").concat(res.status, ". ").concat(triesLeft, " reties left")); // This is temporary to debug 503 on patient site

    if (qos && process.env.ENVK8S === 'production') {
      Promise.all(['http://maiia-prod-api-pat:8080/healthcheck/status/FRONT_PATIENT', 'http://maiia-prod-api-pat:8080/healthcheck/status/FRONT_PATIENT_ENCRYPTION', 'http://maiia-prod-api-pat:8080/pat-public/hcd?limit=10&locality=75001-PARIS&page=0&speciality.shortName=medecin-generaliste'].map(function (qosUrl) {
        return fetchClient(url, fetchOptions).then(function (qosRes) {
          // eslint-disable-next-line no-console
          console.log("[QOS] original url: ".concat(url, ". QOS url: ").concat(qosUrl, ". Status ").concat(qosRes.status, ". ").concat(triesLeft, " reties left"));
        });
      })).catch(function (error) {
        console.error('QOS error', error);
      });
    }

    if (!triesLeft) {
      return {
        ok: false
      };
    }

    return wait(delay).then(function () {
      return fetchRetry(fetchClient, url, delay, triesLeft, fetchOptions, qos);
    });
  }

  return fetchClient(url, fetchOptions).then(function (res) {
    if (!res.ok) {
      return onError(res);
    }

    return res;
  }).catch(function (error) {
    console.error(error);
  });
};

export default fetchRetry;
//# sourceMappingURL=fetchRetry.js.map